import { CartProduct } from "../utils/cartTypes";
import { $cartStore } from "../utils/store";
import { __t } from "../utils/translate";
import { useStore } from "@nanostores/react";

type UseCartData = () => {
    isCartEmpty: boolean;
    subtotal: number;
    total: number;
    discount: number;
    coupon_amount: number;
    shipping: string | number;
    products: CartProduct[];
} | null;

export const useCartData: UseCartData = () => {
    let cart = useStore($cartStore);

    if (typeof cart !== 'object') {
        cart = null;
    }

    const isCartEmpty = !cart?.cart || cart.cart.length === 0;

    const subtotal = cart?.stripe_cart?.order_data.displayItems.subtotal?.amount || 0;
    const discount = cart?.stripe_cart?.order_data.displayItems.discount?.amount || 0;
    const total = cart?.stripe_cart?.order_data.total.amount || 0;
    const shipping =
        cart?.stripe_cart?.order_data.displayItems.shipping?.amount || __t("Free");
    const products = typeof cart?.cart === 'object' ? Array.from(Object.values(cart.cart)) : [];
    products.map(product => {
        if (product.bundled_items?.length && typeof product.bundled_items[0] === 'string') {
            product.bundled_items = products.filter(p => product.key == p.bundled_by);
        }
    })

    let coupon_amount = 0;
    if (cart?.applied_coupons?.length && cart?.applied_coupons_2[cart.applied_coupons[0]]?.discount_type === 'percent') {
        coupon_amount = cart?.applied_coupons_2[cart.applied_coupons[0]].coupon_amount
    }

    return {
        isCartEmpty,
        subtotal,
        total,
        shipping,
        products: products.filter((product) => !product.bundled_by),
        discount,
        coupon_amount,
        applied_coupons: cart?.applied_coupons || null
    };
};
